import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/goodreads': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-0.2 71.8 31.8 78.2 78.3zM448 88v336c0 30.9-25.1 56-56 56h-336c-30.9 0-56-25.1-56-56v-336c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56zM330 313.2c0 0-0.1-34-0.1-217.3h-29v40.3c-0.8 0.3-1.2-0.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9 0.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2 0.5-1 1.1-1.9 1.7-2.9 0.2 0.1 0.4 0.1 0.6 0.2 0.3 3.8 0.2 30.7 0.1 34.5-0.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-0.3-1.6-1.3-1.3-2.3-1.3h-26.8c0.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/goodreads.js
// module id = 705
// module chunks = 0